import { render, staticRenderFns } from "./warticle.vue?vue&type=template&id=3d0783a9"
import script from "./warticle.vue?vue&type=script&lang=js"
export * from "./warticle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports